import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import regeneratorRuntime from "/vercel/path0/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useUser } from "@auth0/nextjs-auth0";
import { Box, Button, Flex, FormControl, FormErrorMessage, FormLabel, GridItem, Heading, Radio, RadioGroup, SimpleGrid, Stack, Text } from "@chakra-ui/react";
import { Logo, PageSpacer } from "@striver/ui";
import Head from "next/head";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
export default function Home() {
    var ref, ref1, ref2;
    var user = useUser().user;
    var router = useRouter();
    var ref3 = useState(false), showResults = ref3[0], setShowResults = ref3[1];
    var ref4 = useForm({
        mode: "all"
    }), handleSubmit = ref4.handleSubmit, control = ref4.control, watch = ref4.watch, setValue = ref4.setValue, errors = ref4.formState.errors;
    function enquire(course) {
        return _enquire.apply(this, arguments);
    }
    function _enquire() {
        _enquire = _async_to_generator(regeneratorRuntime.mark(function _callee(course) {
            var analytics;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if ("object" !== "undefined" && (window === null || window === void 0 ? void 0 : window.analytics)) {
                            analytics = window.analytics;
                            analytics.identify((user === null || user === void 0 ? void 0 : user.sub) ? user === null || user === void 0 ? void 0 : user.sub : "anonymous_events", {
                                email: (user === null || user === void 0 ? void 0 : user.email) ? user === null || user === void 0 ? void 0 : user.email : "anon_events@striver.careers"
                            });
                            analytics.page("Zurich Self Assessment");
                            analytics.track("Self Assessment Enquiry", {
                                course: course
                            });
                        }
                    case 1:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _enquire.apply(this, arguments);
    }
    function submit(data) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = _async_to_generator(regeneratorRuntime.mark(function _callee(data) {
            var analytics;
            return regeneratorRuntime.wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setShowResults(true);
                        if ("object" !== "undefined" && (window === null || window === void 0 ? void 0 : window.analytics)) {
                            analytics = window.analytics;
                            analytics.identify((user === null || user === void 0 ? void 0 : user.sub) ? user === null || user === void 0 ? void 0 : user.sub : "anonymous_events", {
                                email: (user === null || user === void 0 ? void 0 : user.email) ? user === null || user === void 0 ? void 0 : user.email : "anon_events@striver.careers"
                            });
                            analytics.page("Zurich Self Assessment");
                            analytics.track("Self Assessment Submitted", _object_spread({}, data));
                        }
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _submit.apply(this, arguments);
    }
    var watchQ1 = watch("education");
    var watchQ2 = watch("field_of_study");
    useEffect(function() {
        if (showResults) {
            router.query.results = "display";
            router.push(router, undefined, {
                shallow: true
            });
        } else {
            delete router.query.results;
            router.push(router, undefined, {
                shallow: true
            });
        }
    }, [
        showResults
    ]);
    useEffect(function() {
        if (!router.query.results) {
            setShowResults(false);
        } else {
            setShowResults(true);
        }
    }, [
        router
    ]);
    useEffect(function() {
        if (watchQ1 === "Completed Year 12 and/or Cert IV") {
            setValue("field_of_study", null);
        }
    }, [
        watchQ1,
        setValue
    ]);
    return /*#__PURE__*/ _jsx(PageSpacer, {
        isCentered: true,
        isSmaller: true,
        children: /*#__PURE__*/ _jsxs(Box, {
            px: [
                1,
                4
            ],
            py: [
                2,
                4
            ],
            bg: "white",
            children: [
                /*#__PURE__*/ _jsx(Head, {
                    children: /*#__PURE__*/ _jsx("title", {
                        children: "Self Assessment - Education Gap"
                    })
                }),
                /*#__PURE__*/ _jsxs(Box, {
                    children: [
                        /*#__PURE__*/ _jsx(Box, {
                            mb: 10,
                            children: /*#__PURE__*/ _jsx(Logo, {
                                showText: true,
                                fillPrimary: true
                            })
                        }),
                        /*#__PURE__*/ _jsxs(Stack, {
                            justify: "center",
                            mb: 10,
                            direction: [
                                "column",
                                "row"
                            ],
                            align: "center",
                            children: [
                                /*#__PURE__*/ _jsx(Box, {
                                    h: 35,
                                    w: 220,
                                    position: "relative",
                                    mr: 8,
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        alt: "Zurich",
                                        src: "/zurich.jpg",
                                        layout: "fill"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Box, {
                                    h: 35,
                                    w: 90,
                                    position: "relative",
                                    children: /*#__PURE__*/ _jsx(Image, {
                                        alt: "TAFE NSW",
                                        src: "/tafe.jpg",
                                        layout: "fill"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Flex, {
                            justify: "center",
                            mb: 10,
                            px: 5,
                            children: /*#__PURE__*/ _jsx(Heading, {
                                size: "lg",
                                textAlign: "center",
                                children: "Financial Planning Self Assessment Education Gap"
                            })
                        }),
                        !showResults ? /*#__PURE__*/ _jsx(Flex, {
                            justify: "left",
                            px: [
                                4,
                                "20%",
                                "20%"
                            ],
                            mb: 5,
                            minW: [
                                "100%",
                                "lg",
                                "lg"
                            ],
                            children: /*#__PURE__*/ _jsxs("form", {
                                onSubmit: handleSubmit(submit),
                                children: [
                                    /*#__PURE__*/ _jsx(FormControl, {
                                        mb: 8,
                                        isInvalid: Boolean(errors["education"]),
                                        children: /*#__PURE__*/ _jsx(Stack, {
                                            direction: "column",
                                            mb: 4,
                                            children: /*#__PURE__*/ _jsxs(FormControl, {
                                                id: "education",
                                                isInvalid: errors.education,
                                                children: [
                                                    /*#__PURE__*/ _jsx(FormLabel, {
                                                        fontWeight: "bold",
                                                        children: "Highest Level Of Education"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Controller, {
                                                        name: "education",
                                                        control: control,
                                                        render: function(param) {
                                                            var field = param.field;
                                                            return /*#__PURE__*/ _jsx(RadioGroup, _object_spread_props(_object_spread({}, field), {
                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                    direction: "column",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Radio, {
                                                                            value: "Post Graduate",
                                                                            children: "Post Graduate"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Radio, {
                                                                            value: "Under Graduate",
                                                                            children: "Under Graduate"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Radio, {
                                                                            value: "Completed Year 12 and/or Cert IV",
                                                                            children: "Completed Year 12 and/or Cert IV"
                                                                        })
                                                                    ]
                                                                })
                                                            }));
                                                        },
                                                        rules: {
                                                            required: {
                                                                value: true,
                                                                message: "This is required."
                                                            }
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(FormErrorMessage, {
                                                        children: (ref = errors.position) === null || ref === void 0 ? void 0 : ref.message
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    watchQ1 === "Post Graduate" || watchQ1 === "Under Graduate" ? /*#__PURE__*/ _jsx(FormControl, {
                                        mb: 8,
                                        isInvalid: Boolean(errors["field_of_study"]),
                                        children: /*#__PURE__*/ _jsx(Stack, {
                                            direction: "column",
                                            mb: 4,
                                            children: /*#__PURE__*/ _jsxs(FormControl, {
                                                id: "field_of_study",
                                                isInvalid: errors.field_of_study,
                                                children: [
                                                    /*#__PURE__*/ _jsx(FormLabel, {
                                                        fontWeight: "bold",
                                                        children: "Field of study"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Controller, {
                                                        name: "field_of_study",
                                                        control: control,
                                                        render: function(param) {
                                                            var field = param.field;
                                                            return /*#__PURE__*/ _jsx(RadioGroup, _object_spread_props(_object_spread({}, field), {
                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                    direction: "column",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Radio, {
                                                                            value: "Approved Financial Planning Qualification",
                                                                            children: "Approved Financial Planning Qualification"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Radio, {
                                                                            value: "Relevant Accounting, Finance, Economics, Banking",
                                                                            children: "Relevant Accounting, Finance, Economics, Banking"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Radio, {
                                                                            value: "Not Relevant e.g Nursing",
                                                                            children: "Not Relevant e.g Nursing"
                                                                        })
                                                                    ]
                                                                })
                                                            }));
                                                        },
                                                        rules: {
                                                            required: {
                                                                value: true,
                                                                message: "This is required."
                                                            }
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(FormErrorMessage, {
                                                        children: (ref1 = errors.position) === null || ref1 === void 0 ? void 0 : ref1.message
                                                    })
                                                ]
                                            })
                                        })
                                    }) : null,
                                    /*#__PURE__*/ _jsx(FormControl, {
                                        mb: 8,
                                        isInvalid: Boolean(errors["work_experience"]),
                                        children: /*#__PURE__*/ _jsx(Stack, {
                                            direction: "column",
                                            mb: 4,
                                            children: /*#__PURE__*/ _jsxs(FormControl, {
                                                id: "work_experience",
                                                isInvalid: errors.work_experience,
                                                children: [
                                                    /*#__PURE__*/ _jsx(FormLabel, {
                                                        fontWeight: "bold",
                                                        children: "Industry Specific Work Experience"
                                                    }),
                                                    /*#__PURE__*/ _jsx(Controller, {
                                                        name: "work_experience",
                                                        control: control,
                                                        render: function(param) {
                                                            var field = param.field;
                                                            return /*#__PURE__*/ _jsx(RadioGroup, _object_spread_props(_object_spread({}, field), {
                                                                children: /*#__PURE__*/ _jsxs(Stack, {
                                                                    direction: "column",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsx(Radio, {
                                                                            value: "Current e.g Zurich Technical Support",
                                                                            children: "Current e.g Zurich Technical Support"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Radio, {
                                                                            value: "Past",
                                                                            children: "Past"
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(Radio, {
                                                                            value: "None",
                                                                            children: "None"
                                                                        })
                                                                    ]
                                                                })
                                                            }));
                                                        },
                                                        rules: {
                                                            required: {
                                                                value: true,
                                                                message: "This is required."
                                                            }
                                                        }
                                                    }),
                                                    /*#__PURE__*/ _jsx(FormErrorMessage, {
                                                        children: (ref2 = errors.position) === null || ref2 === void 0 ? void 0 : ref2.message
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(FormControl, {
                                        children: /*#__PURE__*/ _jsx(Button, {
                                            type: "submit",
                                            colorScheme: "green",
                                            children: "Submit"
                                        })
                                    })
                                ]
                            })
                        }) : /*#__PURE__*/ _jsxs(Box, {
                            p: 5,
                            children: [
                                /*#__PURE__*/ _jsx(Heading, {
                                    size: "md",
                                    mb: 4,
                                    children: "Required Learning"
                                }),
                                watchQ1 === "Post Graduate" && watchQ2 === "Approved Financial Planning Qualification" ? /*#__PURE__*/ _jsxs(SimpleGrid, {
                                    boxShadow: "md",
                                    border: "1px",
                                    borderColor: "gray.200",
                                    p: 3,
                                    columns: [
                                        1,
                                        7
                                    ],
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ _jsxs(GridItem, {
                                            colSpan: 5,
                                            children: [
                                                /*#__PURE__*/ _jsx(Heading, {
                                                    size: "sm",
                                                    mb: 2,
                                                    children: "Almost There"
                                                }),
                                                /*#__PURE__*/ _jsx(Text, {
                                                    children: "There may be a minimum Ethics Bridging Unit required"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "mailto:marriane.Said1@tafensw.edu.au?subject=Striver - Almost There Enquiry",
                                                children: /*#__PURE__*/ _jsx(Button, {
                                                    onClick: _async_to_generator(regeneratorRuntime.mark(function _callee() {
                                                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    _ctx.next = 2;
                                                                    return enquire("Striver - Almost There Enquiry");
                                                                case 2:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    })),
                                                    colorScheme: "green",
                                                    size: "sm",
                                                    children: "Enquire"
                                                })
                                            })
                                        })
                                    ]
                                }) : null,
                                watchQ1 === "Post Graduate" && watchQ2 === "Relevant Accounting, Finance, Economics, Banking" ? /*#__PURE__*/ _jsxs(SimpleGrid, {
                                    boxShadow: "md",
                                    border: "1px",
                                    borderColor: "gray.200",
                                    p: 3,
                                    columns: [
                                        1,
                                        7
                                    ],
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            colSpan: 5,
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "https://www.tafensw.edu.au/course/-/c/c/HE20529V01/Graduate-Certificate-in-Financial-Planning--Professional-Practice-",
                                                passHref: true,
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ _jsx(Heading, {
                                                        size: "md",
                                                        _hover: {
                                                            cursor: "pointer"
                                                        },
                                                        children: "Graduate Certificate in Financial Planning (Professional Practice)"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                children: "4 units / 1 year"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "mailto:marriane.Said1@tafensw.edu.au?subject=Striver - Graduate Certificate in Financial Planning\n                      (Professional Practice) Enquiry",
                                                children: /*#__PURE__*/ _jsx(Button, {
                                                    onClick: _async_to_generator(regeneratorRuntime.mark(function _callee() {
                                                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    _ctx.next = 2;
                                                                    return enquire("Striver - Graduate Certificate in Financial Planning (Professional Practice) Enquiry");
                                                                case 2:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    })),
                                                    colorScheme: "green",
                                                    size: "sm",
                                                    children: "Enquire"
                                                })
                                            })
                                        })
                                    ]
                                }) : null,
                                watchQ1 === "Post Graduate" && watchQ2 === "Not Relevant e.g Nursing" ? /*#__PURE__*/ _jsxs(SimpleGrid, {
                                    boxShadow: "md",
                                    border: "1px",
                                    borderColor: "gray.200",
                                    p: 3,
                                    columns: [
                                        1,
                                        7
                                    ],
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            colSpan: 5,
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "https://www.tafensw.edu.au/course/-/c/c/HE20530V01/Graduate-Diploma-of-Financial-Planning",
                                                passHref: true,
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ _jsx(Heading, {
                                                        size: "md",
                                                        _hover: {
                                                            cursor: "pointer"
                                                        },
                                                        children: "Graduate Diploma of Financial Planning"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                children: "8 units / 2 years"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "mailto:marriane.Said1@tafensw.edu.au?subject=Striver - Graduate Diploma of Financial Planning Enquiry",
                                                children: /*#__PURE__*/ _jsx(Button, {
                                                    onClick: _async_to_generator(regeneratorRuntime.mark(function _callee() {
                                                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    _ctx.next = 2;
                                                                    return enquire("Striver - Graduate Diploma of Financial Planning Enquiry");
                                                                case 2:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    })),
                                                    colorScheme: "green",
                                                    size: "sm",
                                                    children: "Enquire"
                                                })
                                            })
                                        })
                                    ]
                                }) : null,
                                watchQ1 === "Under Graduate" && watchQ2 === "Approved Financial Planning Qualification" ? /*#__PURE__*/ _jsxs(SimpleGrid, {
                                    boxShadow: "md",
                                    border: "1px",
                                    borderColor: "gray.200",
                                    p: 3,
                                    columns: [
                                        1,
                                        7
                                    ],
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ _jsxs(GridItem, {
                                            colSpan: 5,
                                            children: [
                                                /*#__PURE__*/ _jsx(Heading, {
                                                    size: "sm",
                                                    mb: 2,
                                                    children: "Almost There"
                                                }),
                                                /*#__PURE__*/ _jsx(Text, {
                                                    children: "There may be a minimum Ethics Bridging Unit required"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "mailto:marriane.Said1@tafensw.edu.au?subject=Striver - Almost There Enquiry",
                                                children: /*#__PURE__*/ _jsx(Button, {
                                                    onClick: _async_to_generator(regeneratorRuntime.mark(function _callee() {
                                                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    _ctx.next = 2;
                                                                    return enquire("Striver - Almost There Enquiry");
                                                                case 2:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    })),
                                                    colorScheme: "green",
                                                    size: "sm",
                                                    children: "Enquire"
                                                })
                                            })
                                        })
                                    ]
                                }) : null,
                                watchQ1 === "Under Graduate" && watchQ2 === "Relevant Accounting, Finance, Economics, Banking" ? /*#__PURE__*/ _jsxs(SimpleGrid, {
                                    boxShadow: "md",
                                    border: "1px",
                                    borderColor: "gray.200",
                                    p: 3,
                                    columns: [
                                        1,
                                        7
                                    ],
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            colSpan: 5,
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "https://www.tafensw.edu.au/course/-/c/c/HE20529V01/Graduate-Certificate-in-Financial-Planning--Professional-Practice-",
                                                passHref: true,
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ _jsx(Heading, {
                                                        size: "md",
                                                        _hover: {
                                                            cursor: "pointer"
                                                        },
                                                        children: "Graduate Certificate in Financial Planning (Professional Practice)"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                children: "4 units / 1 year"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "mailto:marriane.Said1@tafensw.edu.au?subject=Striver - Graduate Certificate in Financial Planning\n                      (Professional Practice) Enquiry",
                                                children: /*#__PURE__*/ _jsx(Button, {
                                                    onClick: _async_to_generator(regeneratorRuntime.mark(function _callee() {
                                                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    _ctx.next = 2;
                                                                    return enquire("Striver - Graduate Certificate in Financial Planning (Professional Practice) Enquiry");
                                                                case 2:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    })),
                                                    colorScheme: "green",
                                                    size: "sm",
                                                    children: "Enquire"
                                                })
                                            })
                                        })
                                    ]
                                }) : null,
                                watchQ1 === "Under Graduate" && watchQ2 === "Not Relevant e.g Nursing" ? /*#__PURE__*/ _jsxs(SimpleGrid, {
                                    boxShadow: "md",
                                    border: "1px",
                                    borderColor: "gray.200",
                                    p: 3,
                                    columns: [
                                        1,
                                        7
                                    ],
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            colSpan: 5,
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "https://www.tafensw.edu.au/course/-/c/c/HE20530V01/Graduate-Diploma-of-Financial-Planning",
                                                passHref: true,
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ _jsx(Heading, {
                                                        size: "md",
                                                        _hover: {
                                                            cursor: "pointer"
                                                        },
                                                        children: "Graduate Diploma of Financial Planning"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                children: "8 units / 2 years"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "mailto:marriane.Said1@tafensw.edu.au?subject=Striver - Graduate Diploma of Financial Planning Enquiry",
                                                children: /*#__PURE__*/ _jsx(Button, {
                                                    onClick: _async_to_generator(regeneratorRuntime.mark(function _callee() {
                                                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    _ctx.next = 2;
                                                                    return enquire("Striver - Graduate Diploma of Financial Planning Enquiry");
                                                                case 2:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    })),
                                                    colorScheme: "green",
                                                    size: "sm",
                                                    children: "Enquire"
                                                })
                                            })
                                        })
                                    ]
                                }) : null,
                                watchQ1 === "Completed Year 12 and/or Cert IV" ? /*#__PURE__*/ _jsxs(SimpleGrid, {
                                    boxShadow: "md",
                                    border: "1px",
                                    borderColor: "gray.200",
                                    p: 3,
                                    columns: [
                                        1,
                                        7
                                    ],
                                    spacing: 1,
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            colSpan: 5,
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "https://www.tafensw.edu.au/course/-/c/c/HE20531V02/Bachelor-of-Applied-Commerce-Majoring-in-financial-planning",
                                                passHref: true,
                                                children: /*#__PURE__*/ _jsx("a", {
                                                    target: "_blank",
                                                    children: /*#__PURE__*/ _jsx(Heading, {
                                                        size: "md",
                                                        _hover: {
                                                            cursor: "pointer"
                                                        },
                                                        children: "Bachelor of Applied Commerce Majoring in Financial Planning"
                                                    })
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Text, {
                                                children: "24 units / 3 years"
                                            })
                                        }),
                                        /*#__PURE__*/ _jsx(GridItem, {
                                            children: /*#__PURE__*/ _jsx(Link, {
                                                href: "mailto:marriane.Said1@tafensw.edu.au?subject=Striver - Bachelor of Applied Commerce Majoring in Financial\n                      Planning",
                                                children: /*#__PURE__*/ _jsx(Button, {
                                                    onClick: _async_to_generator(regeneratorRuntime.mark(function _callee() {
                                                        return regeneratorRuntime.wrap(function _callee$(_ctx) {
                                                            while(1)switch(_ctx.prev = _ctx.next){
                                                                case 0:
                                                                    _ctx.next = 2;
                                                                    return enquire("Striver - Bachelor of Applied Commerce Majoring in Financial Planning");
                                                                case 2:
                                                                case "end":
                                                                    return _ctx.stop();
                                                            }
                                                        }, _callee);
                                                    })),
                                                    colorScheme: "green",
                                                    size: "sm",
                                                    children: "Enquire"
                                                })
                                            })
                                        })
                                    ]
                                }) : null,
                                /*#__PURE__*/ _jsxs(Box, {
                                    mt: 10,
                                    mb: 10,
                                    children: [
                                        /*#__PURE__*/ _jsx(Button, {
                                            mb: 10,
                                            variant: "outline",
                                            size: "sm",
                                            colorScheme: "red",
                                            onClick: function() {
                                                return setShowResults(false);
                                            },
                                            children: "Reset"
                                        }),
                                        /*#__PURE__*/ _jsx(Heading, {
                                            size: "sm",
                                            mb: 4,
                                            children: "Join the Striver Community"
                                        }),
                                        /*#__PURE__*/ _jsx(Button, {
                                            colorScheme: "blue",
                                            onClick: function() {
                                                window.open("https://www.striver.careers/");
                                            },
                                            children: "Create account"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs(Box, {
                                    children: [
                                        "Visit the",
                                        " ",
                                        /*#__PURE__*/ _jsx(Link, {
                                            href: "https://ziapac.sharepoint.com/sites/AUZurichAssure/SitePages/Professional-Year.aspx",
                                            passHref: true,
                                            children: /*#__PURE__*/ _jsx("a", {
                                                target: "_blank",
                                                children: "Zurich Adviser Academy"
                                            })
                                        }),
                                        " ",
                                        "for more information on joining Zurich Assure"
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Box, {
                    p: 5,
                    color: "gray.500",
                    children: [
                        /*#__PURE__*/ _jsx(Text, {
                            fontSize: "xs",
                            mb: 2,
                            children: "This diagnostic tool is provided by Striver Pty Ltd. Please note, this diagnostic tool assesses against the requirements to obtain accreditation through TAFE NSW programs only, and the content of each of component subject or other element (eg practical) if applicable. TAFE NSW is used simply as an example and that other providers' curricula could differ. Any results should be used only as a guide, and users should not make decisions based on it. Instead they should check their particular 'advance standing' status with their preferred education / accreditation provider. Zurich does not have any affiliations with TAFE NSW or receives any benefit or endorses its courses. TAFE NSW courses are used just to assist in providing indicative guidance and not being recommended. A range of providers can assist and each interested person should do their own research."
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            fontSize: "xs",
                            children: "The content used by the diagnostic tool is derived from sources believed to be true as at July 2022 date and may be subject to change. It is derived from sources believed to be accurate at this date. It should not be considered to be a comprehensive statement on any matter and should not be relied on as such."
                        }),
                        /*#__PURE__*/ _jsx(Text, {
                            fontSize: "xs",
                            children: "TAFE NSW - Registered Training Organisation: 90003; CRICOS Provider Number 00591E; Higher Education Provider PRV12049"
                        })
                    ]
                })
            ]
        })
    });
};
